import { createFileRoute } from "@tanstack/react-router";
import { replaceWithBareModule } from "@/app/module-address";
import { PendingSurface } from "@/components/feedback/pending-surface";
import { requirePerm } from "@/lib/auth/guards";
export const Route = createFileRoute("/_authenticated/pos")({
  beforeLoad: (args) => {
    replaceWithBareModule("/pos", args.location);
    requirePerm("OPERATE_POS")(args);
  },
  component: () => <PendingSurface titleKey="nav.pos" />,
});
